import AIResume from 'pagecomponents/AIResume';
export default Object.assign(AIResume, { requiresPlacesApi: false });
